export interface MonthlyThemeUser {
  avatar: string;
  name: string;
  level: string;
  link: string;
  to?: string;
  iconUrl?: string;
  description?: string;
  userId?: string;
  counts?: string;
}

export interface MonthlyThemePage {
  id: number;
  title: string;
  items: Array<MonthlyThemeUser>;
  icon?: string;
}

export enum MonthlyThemeFilter {
  Customers = "Customers / Partners",
  Employees = "Oracle Employees",
}
